import { DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM } from "../enums/documentsSignInModalTitleEnum";

export const DOCUMENTS_SIGN_IN_MODAL_TITLE = {
    [DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM.SELECT_SIGN_IN] : "Подписать документы",
    [DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM.CONSFIRM_TEXT]: "Подписать документы",
    [DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM.ECP_ANIMATION]: "Выполняется процесс подписания документов",
    [DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM.FINISH ]: "Документы успешно подписаны",
};
